import cn from "classnames";
import React from "react";
import { clearLogo, editLogo } from "sources/books/legalPersons";

export default function LegalPersonLogo({ data, id, loading, setLoading, modal, onUpdate }) {
    const logoUrl = data?.logo?.accessUrlLink;

    const uploadLogo = () => {
        modal({
            name: "fileUpload",
            accept: ".png, .jpg, .jpeg",
            propName: "file",
            title: "Загрузка логотипа",
            uploadFile: (params) => {
                params.body.append("id", id);
                setLoading(true);

                return editLogo(params).catch((err) => {
                    setLoading(false);
                    throw err;
                });
            },
            action: () => onUpdate().finally(() => setLoading(false)),
        });
    };

    const removeLogo = () => {
        modal({
            name: "confirm",
            title: "Удаление логотипа",
            text: "Вы уверены, что хотите удалить логотип?",
            action: () => {
                setLoading(true);
                clearLogo({ id })
                    .then(onUpdate)
                    .catch(() => undefined)
                    .finally(() => setLoading(false));
            },
            buttons: { confirm: "Удалить", cancel: "Отмена" },
        });
    };

    return (
        <div className={cn("mb-3", { "loading loading--small": loading })}>
            <div className="row mb-2">
                <div className="col-form-label col-form-label-sm col-12 text-muted">Изображение организации</div>
                <div className="col-12">
                    {logoUrl ? (
                        <div className="mb-2">
                            <img className="mw-150" src={logoUrl} alt="Логотип организации" />
                        </div>
                    ) : (
                        <div className="text-muted mb-2">Логотип не загружен</div>
                    )}
                    <button className="btn btn-xs btn-secondary mr-2" type="button" onClick={uploadLogo}>
                        {logoUrl ? "Заменить" : "Загрузить"}
                    </button>
                    {logoUrl && (
                        <button className="btn btn-xs btn-outline-danger" type="button" onClick={removeLogo}>
                            Удалить
                        </button>
                    )}
                    <div>
                        <small>
                            <i className="text-info">Только файлы формата jpeg/jpg/png</i>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    );
}
